import minesweeperImg from "../../assets/projectImages/minesweeper.png";
import weatherAppImg from "../../assets/projectImages/weather-app.png";
import meAuImg from "../../assets/projectImages/me-au-home.png";
import wordleImg from "../../assets/projectImages/wordle.png";

export type Tech =
  | "html"
  | "css"
  | "js"
  | "typescript"
  | "nodejs"
  | "reactjs"
  | "postgresql"
  | "express";

export interface IProject {
  title: string;
  image: string;
  repoLink: string;
  demoLink: string;
  description: string;
  facts: string[];
  stack: Tech[];
  solo: boolean;
}

export const projects: IProject[] = [
  {
    title: "Minesweeper",
    image: minesweeperImg,
    repoLink: "https://github.com/nicholas1301/minesweeper-clone",
    demoLink: "https://nicholas1301.github.io/minesweeper-clone/",
    description:
      "A simple clone of the classic minesweeper game, reverse engineered with vanilla JavaScript.",
    facts: [
      "Using the custom difficulty settings, the game grid can be made arbitrarily large (and proportionately slow… experiment at your own risk)",
      "In minesweeper, when a blank square is clicked (one with zero bombs adjacent to it), the entire safe region of the grid containing that square opens up. This effect was implemented using breadth-first search",
      "The first square the player clicks will always be a safe square (will never contain a bomb)",
    ],
    stack: ["html", "css", "js"],
    solo: true,
  },
  {
    title: "Weather App",
    image: weatherAppImg,
    repoLink: "https://github.com/nicholas1301/weather-app",
    demoLink: "https://weather-app-nicholas1301.vercel.app/",
    description:
      "A tool to consult weather data for the user's location as well as any city in the world.",
    facts: [
      "Features dynamic background images which depend on user’s location as well as on the current weather condition",
      "The search bar has an autocomplete feature to suggest names of existing cities. It was implemented from scratch by sending a search request to TeleportAPI at every keystroke",
    ],
    stack: ["typescript", "reactjs"],
    solo: true,
  },
  {
    title: "Me-Au Pet Hotel",
    image: meAuImg,
    repoLink: "https://github.com/nicholas1301/me-au-back-end",
    demoLink: "https://me-au.vercel.app/",
    description:
      "Full stack application to manage a pet hotel's reservation scheduling system.",
    facts: [
      "~90% code coverage was achieved with integration tests",
      "Available in portuguese and english - i18n was used for internationalization",
      "Features Google OAuth integration and password recovery service",
    ],
    stack: ["typescript", "reactjs", "nodejs", "express", "postgresql"],
    solo: false,
  },
  {
    title: "Wordle",
    image: wordleImg,
    repoLink: "https://github.com/nicholas1301/clone-termo",
    demoLink: "https://nicholas1301.github.io/clone-termo/",
    description:
      "A simple clone of the word guessing game Wordle, featuring a portuguese word list.",
    facts: [
      "Unlike the original, you can play more than once a day: a new random word is generated at every page refresh",
    ],
    stack: ["html", "css", "js"],
    solo: true,
  },
  // {
  //   title: "Kenzie-Hub",
  //   image: '',
  //   repoLink: 'https://github.com/nicholas1301/kenzie-hub',
  //   demoLink: '',
  //   description: '',
  //   facts: [],
  //   stack: []
  // }
];
